import { useEffect } from 'react'

const useKeyPress = (targetKey: string | number, callback: () => void): void => {
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === targetKey || e.keyCode === targetKey) {
      callback()
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown)

    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [targetKey, callback])
}

export default useKeyPress
